export default "/imgs/investigation-04-mob.png"